import { useAuth } from '../auth/AuthContext'
import { formatRole } from '../lib/format'
import { Icon } from '../ui/primitives'

/** Shown while a system administrator views the portal as another role
    (profile menu → Roles) or as another user (Activity → View this Role). */
export default function PreviewBanner() {
  const { preview, stopPreview } = useAuth()
  if (!preview) return null
  const asUser = preview.kind === 'user'
  return (
    <div className="preview-banner" role="status">
      <Icon name="eye" />
      <span className="preview-banner-text">
        {asUser ? (
          <>
            Viewing as <strong>{preview.user_name}</strong>
            {preview.role_name ? <> ({formatRole(preview.role_name)})</> : null}
            {' · read-only — exactly what they see.'}
          </>
        ) : (
          <>
            Viewing as <strong>{formatRole(preview.role_name)}</strong>. Read-only — changes are
            switched off while viewing as another role.
          </>
        )}
      </span>
      <button type="button" className="btn btn-sm preview-banner-exit" onClick={stopPreview}>
        {asUser ? 'Exit to my view' : `Exit to ${formatRole(preview.real_role_name) || 'my view'}`}
      </button>
    </div>
  )
}
